import React, { useState, useEffect } from 'react';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import Table from '../../components/ui/Table';
import api from '../../services/api';

function ExpiryStatus({ days }) {
  if (days === undefined || days === null) return <span style={{ color: '#CBD5E1' }}>&mdash;</span>;
  if (days <= 0) return <Badge variant="error">Просрочен</Badge>;
  if (days <= 3) return <Badge variant="urgent">Критический ({days} дн.)</Badge>;
  if (days <= 7) return <Badge variant="warning">Скоро ({days} дн.)</Badge>;
  return <Badge variant="success">Норма ({days} дн.)</Badge>;
}

export default function ExpiryMonitoring() {
  const [days, setDays] = useState(30);
  const [products, setProducts] = useState([]);
  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      setLoading(true);
      try {
        const res = await api.get(`/v1/products/expiry?days=${days}`);
        if (res?.data) {
          setProducts(res.data.products || []);
          setSummary(res.data.summary || {});
        }
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    }
    load();
  }, [days]);

  const columns = [
    { key: 'name', label: 'Товар', render: (v, row) => (
      <div>
        <div style={{ fontWeight: 600, fontSize: 13 }}>{v}</div>
        <div style={{ fontSize: 11, color: '#94A3B8' }}>{row.barcode || ''}</div>
      </div>
    )},
    { key: 'brand', label: 'Бренд', render: v => v || '\u2014' },
    { key: 'category_name', label: 'Категория', render: v => v ? <Badge variant="primary">{v}</Badge> : '\u2014' },
    { key: 'nearest_expiry', label: 'Срок годности', render: v => v ? new Date(v).toLocaleDateString('ru-RU') : '\u2014' },
    { key: 'days_until_expiry', label: 'Статус', render: v => <ExpiryStatus days={v} /> },
    { key: 'stock_quantity', label: 'Остаток', render: (v, row) => <span>{v || 0} {row.unit || 'шт'}</span> },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h1 style={{ fontSize: 24, fontWeight: 800, color: '#0F172A', letterSpacing: '-0.02em' }}>Мониторинг сроков годности</h1>
          <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 2, fontWeight: 500 }}>Товаров с истекающим сроком: {products.length}</p>
        </div>
        <select value={days} onChange={e => setDays(Number(e.target.value))} style={{
          padding: '8px 14px', border: '1.5px solid #E2E8F0', borderRadius: 10,
          fontSize: 13, background: '#fff', cursor: 'pointer', fontFamily: 'inherit', color: '#334155',
        }}>
          <option value={7}>7 дней</option>
          <option value={14}>14 дней</option>
          <option value={30}>30 дней</option>
          <option value={90}>90 дней</option>
        </select>
      </div>

      {/* Summary */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12 }}>
        {[
          { label: 'Просрочено', value: summary.expired || 0, color: '#EF4444', bg: '#FEF2F2' },
          { label: 'Критический (1 дн.)', value: summary.critical_1_day || 0, color: '#EA580C', bg: '#FFF7ED' },
          { label: 'Внимание (3 дн.)', value: summary.warning_3_days || 0, color: '#D97706', bg: '#FFFBEB' },
          { label: 'Скоро (5 дн.)', value: summary.attention_5_days || 0, color: '#10B981', bg: '#ECFDF5' },
        ].map(s => (
          <div key={s.label} style={{
            background: s.bg, borderRadius: 14, padding: '18px 20px', textAlign: 'center',
            border: `1px solid ${s.color}15`,
            transition: 'transform 0.2s',
          }}
            onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-1px)'}
            onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}>
            <div style={{ fontSize: 30, fontWeight: 800, color: s.color, letterSpacing: '-0.02em' }}>{s.value}</div>
            <div style={{ fontSize: 12, color: '#64748B', marginTop: 4, fontWeight: 500 }}>{s.label}</div>
          </div>
        ))}
      </div>

      <Card padding="0">
        {loading ? (
          <div style={{ textAlign: 'center', padding: 48, color: '#94A3B8' }}>
            <div style={{ width: 28, height: 28, borderRadius: '50%', border: '3px solid rgba(0,206,238,0.15)', borderTopColor: '#00CEEE', animation: 'spin 0.8s linear infinite', margin: '0 auto 10px' }} />
            Загрузка...
          </div>
        ) : (
          <Table columns={columns} data={products} emptyText="Нет товаров с истекающим сроком" />
        )}
      </Card>
    </div>
  );
}
